import { useEffect } from 'react';
import { useRuntimeConfig } from '@/hooks/useRuntimeConfig';
import { applyFavicon } from '@/utils/apply-favicon';

/**
 * Keeps the browser favicon in sync with the runtime tenant config. Call once
 * near the app root. Replaces the legacy TenantContainer path that wrote the
 * favicon from custom-info's icon_uri.
 */
export const useApplyFavicon = () => {
  const config = useRuntimeConfig();

  useEffect(() => {
    applyFavicon(config?.style?.favicon);
  }, [config?.style?.favicon]);
};
